import 'select2';
import 'select2/dist/css/select2';
import '@simonwep/pickr/dist/themes/classic.min.css';
import { Controller } from "stimulus";
import BatchService from '../entrypoints/src/admin/services/batch-service';

export default class extends Controller {
  connect() {
    this.buildSelectBatchModal();
    this.modalSelectBatch = document.querySelector('.modal#composition-select-batch-modal');
    this.$selectBatch = this.modalSelectBatch.querySelector('select.select-batch');
    this.$buttonBatch = this.modalSelectBatch.querySelector('button#select-button-batch');
    this.$buttonBatch.addEventListener('click', this.onSelectBatch.bind(this));
    $('#composition-select-batch-modal').on('shown.bs.modal', (ev) => {
      if (!$(this.$selectBatch).data('select2'))
        this.initializeSelectBatch();
    });
  }

  selectNewBatch() {
    $(this.modalSelectBatch).modal('show');
  }

  onSelectBatch() {
    this.printoutBatch($(this.$selectBatch).select2('data')[0]);
    $(this.modalSelectBatch).modal('hide');
  }

  removeBatch(ev) {
    let card = ev.currentTarget.closest('.selected-batch-card');
    card.classList.remove('show');
    setTimeout(() => { card.remove() }, 250)
  }

  printoutBatch(batch) {
    this.element.querySelector('#selected-batches').insertAdjacentHTML('beforeEnd', `
      <div class="border selected-batch-card rounded-lg p-4 d-flex align-items-center flex-column position-relative fade show on-hover">
        <input type="hidden" name="${this.element.dataset.objectName}[batch_ids][]" value="${batch.id}" />
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10 mb-3">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
        </svg>
        <span class="text-capitalize font-weight-500">${batch.text.toLowerCase()}</span>
        <a data-action="batch-composition#removeBatch" role="button" class="position-absolute text-light fade on-hover-show" style="top: 10px; right: 10px">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
        </a>
      </div>
    `);
  }

  async buildSelectBatchModal() {
    if (!!document.querySelector('.modal#composition-select-batch-modal'))
      return;

    document.body.insertAdjacentHTML('beforeEnd',
      `<div class="modal fade" id="composition-select-batch-modal" data-backdrop="true" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header border-0">
              <div class="d-flex justify-content-between align-items-center stretch">
                <h5 class="mb-0">Selecionar Turma</h5>

                <button type="button" class="close mx-1" data-dismiss="modal" aria-label="Close">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
                </button>
              </div>
            </div>
            <div class="modal-body">
              <select class="select-batch"></select>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-gray-primary" data-dismiss="modal">Fechar</button>
              <button type="button" class="btn btn-green-500" id="select-button-batch">(+) Adicionar</button>
            </div>
          </div>
        </div>
      </div>`
    );

    if (!this.batches)
      this.batches = await BatchService.all(this.element.dataset.service);
  }

  initializeSelectBatch() {
    $(this.$selectBatch)
      .select2({
        data: this.batches.map((i) => { return { id: i.id, text: `${i.name.toUpperCase()} - ${i.week_day_schedules}` }} ),
        placeholder: 'Encontrar Aluno',
        allowClear: true,
        dropdownParent: this.modalSelectBatch,
        escapeMarkup: (markup) => markup,
        templateResult: this.template,
        templateSelection: this.template,
      });
  }

  template(batch) {
    return `<span><span class="font-capitalize">${batch.text.toLowerCase()}</span></span>`;
  }
}